import { Button } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { MicIcon, X } from 'lucide-react'

export const WaitingForSessionStep = ({ onBack }: { onBack: () => void }) => {
  return (
    <div className="m-auto mx-auto flex w-full max-w-[800px] flex-col items-center gap-4">
      <div className="flex w-full grow flex-col gap-4 rounded-2xl border border-solid border-gray-100 p-6">
        <div className="text-body-3 text-gray-90">&#8226; Topic to discuss</div>
        <div className="text-h5 leading-[110%] whitespace-pre-line">
          <Trans>Conversation will start shortly...</Trans>
        </div>
        <div className="text-gray-80 text-body-2 mr-auto max-w-[800px]">
          <Trans>Discuss the topic casually, like old acquaintances.</Trans>
        </div>
      </div>
      <div className="flex w-full flex-col items-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-8">
        <div className="bg-black-to-white mt-4 flex size-24 items-center justify-center rounded-full">
          <div className="flex size-20 items-center justify-center rounded-full bg-gray-100">
            <MicIcon className="text-gray-80 size-10" />
          </div>
        </div>
        <div className="flex w-full flex-col items-center gap-8 border-t border-solid border-gray-100 pt-5">
          <div className="flex items-center justify-center gap-2">
            <span className="size-2 animate-pulse rounded-full bg-amber-500" />{' '}
            <span className="text-body-2 text-gray-90">
              <Trans>Waiting for participants to join...</Trans>
            </span>
          </div>
          <Button variant="bordered-gray" size="small" onClick={onBack} className="mt-2 gap-2">
            <X className="size-5" />
            <Trans>Leave</Trans>
          </Button>
        </div>
      </div>
    </div>
  )
}
